module.exports = __webpack_public_path__ + "static/media/external-link.256301b5.svg";